
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import AnimateOnScroll from './ui/AnimateOnScroll';
import Lottie from 'lottie-react';
import faqAnimation from '../assets/faq-animation.json';

const faqs = [
  {
    question: "מה כוללת פגישה ראשונית?",
    answer: "השיחה הראשונית כוללת הבנה של הבעיות הקיימות כיום בעסק ובדיקה ראשונית של פתרונות אפשריים. הפגישה נמשכת כרבע שעה בשיחת וידאו."
  },
  {
    question: "מה כוללות פגישות איפיון ?",
    answer: " פגישות האפיון כוללות ניתוח מפורט של התהליכים בעסק, זיהוי תהליכים שניתן לייעל, ותכנון מפורט של פתרונות רלונטיים. מספר הפגישות הנדרשות, תלוי בהיקף התהליכים הנבחנים ומתקיימות בשיחת וידאו."
          },
  {
    question: "כמה זמן לוקח להטמיע מערכת חדשה?",
    answer: "זמן ההטמעה משתנה בהתאם למורכבות המערכת והיקף השימוש. הטמעת מערכות מדף יכולה להימשך בין שבוע לחודש, בעוד שפיתוח מערכת מותאמת אישית עשוי להימשך בין חודש לשלושה חודשים."
  },
  {
    question: "האם  יש תמיכה לאחר הטמעת המערכת?",
    answer: "בהחלט! לכל לקוח מוצעת חבילת תמיכה  המותאמת לצרכיו, החל מתמיכה טכנית בסיסית ועד לליווי מלא הכולל עדכונים, שדרוגים והדרכות נוספות לצוות."
  },
  
  {
    question: "האם ניתן לקבל הדרכה על השימוש במערכות  שיוטמעו אצלי?",
    answer: "בוודאי! כל פרויקט הטמעה כולל הדרכה מקיפה לצוות שיעבוד עם המערכת. "
  }
];

const FaqSection = () => {
  return (
    <section id="faq" className="py-12 bg-white relative">
      <div className="absolute right-0 bottom-20 w-32 h-32 opacity-20 z-0">
        <Lottie animationData={faqAnimation} loop={true} />
      </div>
      
      <div className="section-container relative z-10">
        <AnimateOnScroll animation="animate-fade-in">
          <h2 className="section-title text-tech-darkGray">שאלות נפוצות</h2>
        </AnimateOnScroll>
        
        <div className="max-w-3xl mx-auto mt-12">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AnimateOnScroll
                key={index}
                animation="animate-fade-in"
                delay={index * 100}
              >
                <AccordionItem value={`item-${index}`} className="border-b border-gray-200 py-2">
                  <AccordionTrigger className="text-right text-lg font-medium text-tech-darkGray hover:text-tech-blue transition-colors">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 text-right">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </AnimateOnScroll>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
